var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3cd6f49067ea682881d87f0f321ca9914c56a9d9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breitbart-nextjs-web@sentry"]={id:"3cd6f49067ea682881d87f0f321ca9914c56a9d9"};
      